import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import { formElements, LoadingPane } from '@social-solutions/ssg-forms';
import { formDefinition } from '@social-solutions/ssg-forms-processing';
import { Title } from '../layout';
import { BasicCard, ssgFormsAdapters } from "../common";
import * as programEnrollmentUtils from '../common/program-enrollment-utilities';
import './dashboard.scss';
import { features, RequireFeatureComponent } from '../features';
import { integrationTypes } from '../tenantInfo';
import defaultCardStyle from "../common/widgets/basic-card.style";
import * as api from '../api';

export class DashboardComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      programSelection: null,
      siteSelection: null,
      showAllForms: false,
      permissions: [],
    }
  }

  /**
   * Sets the selected site value in local state. (does not affect the api query)
   * Resets the program selection if the value changes.
   * @param {*} site a list of option values
   */
  handleSiteChange(site) {
    const { siteSelection } = this.state;
    var newSite = (site && site.size > 0) ? site.get(0) : "";
    if(newSite === "" || siteSelection !== newSite) {
      this.setState({programSelection: ""});
    }
    this.setState({siteSelection: newSite});
  }

  /**
   * Sets the selected program value in local state. (does not affect the api query)
   * @param {*} program a list of option values
   */
  handleProgramChange(program) {
    var newProgram = (program && program.size > 0) ? program.get(0) : "";
    this.setState({programSelection: newProgram});
  }

  /** Displays a SelectElement with all the sites as options */
  renderSiteDropdown() {
    const { programEnrollment } = this.props;
    const { siteSelection } = this.state;

    const { enrollment } = programEnrollment;
    const { sites } = enrollment || {};
    var siteOptions = [{
      label: "All Locations",
      value: "",
    }];
    if(sites) {
      const siteList = sites.map(site => ({ label: site.name, value: site.siteId }));
      siteOptions.push(...siteList);
    }

    var siteStyle = Object.assign({}, formElements.defaultElementStyles.select);
    siteStyle.select += " header-filter-dropdown";

    const sitesDropdown = {
      id: 'sites',
      label: '',
      ariaLabel: 'locations filter',
      type: formDefinition.elementTypes.select,
      options: siteOptions
    };

    return (
      <formElements.SelectElement
        disableEmptyOption={true}
        element={sitesDropdown}
        value={(siteSelection !== undefined && siteSelection !== null) ? List([siteSelection]) : undefined}
        defaultValue={undefined}
        onChange={(val) => this.handleSiteChange(val)}
        css={siteStyle}/>
    );
  }

  /** Displays a SelectElement with all the programs as options, disabled if a site has not been selected */
  renderProgramDropdown() {
    const { programEnrollment } = this.props;
    const { siteSelection, programSelection, } = this.state;

    const { enrollment } = programEnrollment;
    const { sites } = enrollment || {};

    var programOptions = [{
      label: "All Programs/Services",
      value: "",
    }];
    const selectedSiteId = (siteSelection !== null && siteSelection !== undefined) ? siteSelection : null;
    if(selectedSiteId && sites) {
      const selectedSite = sites.find(site => site.siteId === selectedSiteId);
      const programList = selectedSite.programs ? selectedSite.programs.map(program => ({ label: !program.alias ? program.name : program.alias, value: program.programId })) : [];
      programOptions.push(...programList);
    }

    var programStyle = Object.assign({}, formElements.defaultElementStyles.select);
    programStyle.select += " header-filter-dropdown";

    const programsDropdown = {
      id: 'programs',
      label: '',
      ariaLabel: 'programs filter',
      type: formDefinition.elementTypes.select,
      options: programOptions,
      disabled: !selectedSiteId,
    };

    return (
      <formElements.SelectElement
        disableEmptyOption={true}
        element={programsDropdown}
        value={(programSelection !== undefined && programSelection !== null) ? List([programSelection]) : undefined}
        defaultValue={undefined}
        onChange={(val) => this.handleProgramChange(val)}
        css={programStyle}/>
    );
  }

  renderRequestAppointmentButton() {
    return(
      <button onClick={() => this.props.history.push('/requestappointments')} className='ssg-forms-btn ssg-forms-btn-primary  request-button'>
        Request Appointment
      </button>
    )
  }

  /**
   * handle when user chooses to fill out new form response
   * @param {string} siteId
   * @param {string} programId
   * @param {string} formId
   */
  handleAddNewResponse(siteId, programId, formId) {
    const { redirectTo } = this.props;
    redirectTo(`/sites/${siteId}/programs/${programId}/forms/${formId}/create`);
  }

  /** handle user clicking show more (forms) */
  handleShowAllClick() {
    this.setState({showAllForms: true});
  }

  /**
   * handle user navigating to the history of form submissions
   */
  handleViewSubmissions() {
    const { redirectTo } = this.props;
    redirectTo(`/responses`);
  }

  componentDidMount() {
    api.get('/sessions/permissions', null)
    .then(res => res)
    .then(res => {
      this.setState({permissions: res})
    })
  }

  render() {
    const { auth, programEnrollment, tenant } = this.props;
    const { siteSelection, programSelection, showAllForms, permissions } = this.state;
    const { err: enrollmentErr, isFetching: enrollmentFetching, enrollment } = programEnrollment;
    const { participantInfo, currentSession } = auth;
    const { data } = participantInfo || {};
    const { user } = currentSession || {};
    const { firstName } = !!data ? data : user || {};
    const { featureList } = tenant.currentTenant;

    // get all forms available to participant
    const allAvailableForms = programEnrollmentUtils.getFormsWithAddPermission(programEnrollment, siteSelection, programSelection);
    const allAvailableLength = allAvailableForms.length;
    // either show first (at most) 6 forms, or all
    const availableSubset = showAllForms ? allAvailableForms : allAvailableForms.slice(0, 6);
    const apricotSchedulerEnabled = permissions.length > 0 ? permissions.filter(p => p.name === 'ConnectScheduler')[0].enabled : false;
    const connectSchedulerEnabled = featureList.length > 0 ? featureList.filter(p => p.name === 'ConnectScheduler')[0].enabled : false;

    return (
      <div id="connect-dashboard">
        <Title title="Dashboard"/>
        <div id="dashboard-header" >
          <h1 className="ssg-forms-text xl page-title">
            {!!firstName ? `Welcome, ${firstName}!` : "Welcome!"}
          </h1>
          <span className="header-filter">
            <span className="ssg-forms-text normal header-filter-text">View</span>
            {this.renderSiteDropdown()}
            {this.renderProgramDropdown()}
          </span>
          {apricotSchedulerEnabled && connectSchedulerEnabled && this.renderRequestAppointmentButton()}
        </div>
        <div className="dashboard-main-view">
          <RequireFeatureComponent
              requiredFeatures={[features.apricotPortalTier2]}
              requiredForIntegrationTypes={[integrationTypes.apricot]}>
              <div className="dashboard-section-header">
                <span className="dashboard-section-header-text">
                  Available Forms<span className="count-indicator">{allAvailableLength}</span>
                </span>
                <span>
                  <button
                    id="view-submissions-btn"
                    className="ssg-forms-btn ssg-forms-btn-secondary"
                    onClick={() => this.handleViewSubmissions()}>VIEW FORM SUBMISSIONS</button>
                </span>
              </div>
              <LoadingPane
                loadingState={ssgFormsAdapters.convertLoadingState({ err: enrollmentErr, isFetching: enrollmentFetching, data: enrollment })}
                loadingMessage={"Loading Forms..."}>
                <div id="avail-forms-section">
                  {availableSubset.map( (form, index) => (
                      <BasicCard
                        key={form.id}
                        body={<div>
                          <b>{programEnrollmentUtils.getSiteName(programEnrollment, form.siteId)}</b> - {programEnrollmentUtils.getProgramName(programEnrollment, form.programId)}
                        </div>
                        }
                        buttonText="FILL OUT"
                        cardId={form.id}
                        header="AVAILABLE"
                        onButtonClick={() => this.handleAddNewResponse(form.siteId, form.programId, form.touchpointId)}
                        title={!form.alias ? form.externalName : form.alias}
                        css={(index + 1) % 3 === 0 ?
                          {cardWrapper: defaultCardStyle.cardWrapper + " dashboard-card"} : {cardWrapper: defaultCardStyle.cardWrapper + " dashboard-card card-space"}} />
                  ))}
                  { allAvailableLength > 6 ?
                    <div id="show-more-btn-wrapper" className={showAllForms ? "hidden" : ""}>
                      <button className="ssg-forms-btn ssg-forms-btn-primary" onClick={() => this.handleShowAllClick()}>SHOW MORE</button>
                    </div>
                  : null }
                </div>
              </LoadingPane>
            </RequireFeatureComponent>
        </div>
      </div>
    );
  }
}

DashboardComponent.propTypes = {
  auth: PropTypes.any.isRequired,
  routing: PropTypes.any.isRequired,
  programEnrollment: PropTypes.any.isRequired,
};

const mapStateToProps = ({ routing, auth, programEnrollment, tenant }) => {
  return {
    auth,
    routing,
    programEnrollment,
    tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: bindActionCreators(push, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);



// WEBPACK FOOTER //
// src/dashboard/dashboard.component.js